export const VIEW_TYPES = {
  mobile: 'Mobile',
  tablet: 'Tablet',
  desktop: 'Desktop',
};
